import React, { FC, memo } from 'react';
import { Container } from './styles';
import { Props } from './types';

const Bold: FC<Props> = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};

export default memo(Bold);
